import { AfterContentChecked, Component, ElementRef, Inject, ViewChild, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CarouselImage } from "@board/cloud-library/components/carousel";
import { Observable, map } from "rxjs";
import {
  DemoAssetPopupViewModel,
  DemoModulePopupViewModel,
  DemoTileViewModel,
  MaterialModuleModel
} from "src/app/core/model/ContentManagement";
import { CollectionService } from "src/app/services/collection.service";
import { DemoAssetService } from "src/app/services/demo-asset.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

export interface DemoPopupData {
  demo: DemoTileViewModel;
  canAddToCollection: boolean;
  startFullScreen: boolean;
}

@Component({
  selector: "brd-demo-popup",
  templateUrl: "./demo-popup.component.html",
  styleUrl: "./demo-popup.component.less",
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class DemoPopupComponent implements AfterContentChecked {
  @ViewChild("industriesChips") industriesChips: ElementRef;

  protected demo: DemoAssetPopupViewModel;
  protected carouselObs$: Observable<CarouselImage[]>;
  protected startFullScreen = false;
  protected loading = false;
  protected industries = [];
  protected materials: MaterialModuleModel[] = [];
  protected modules: DemoModulePopupViewModel[] = [];
  protected canAddToCollection: boolean = false;
  protected lastUpdate: Date;

  industriesExpandable = false;

  public constructor(
    public dialogRef: MatDialogRef<DemoPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DemoPopupData,
    private demoAssetService: DemoAssetService,
    private collectionService: CollectionService
  ) {
    this.carouselObs$ = this.demoAssetService.getAssetCarousel(data.demo.id).pipe(
      map(res => {
        return res.images;
      })
    );

    this.loading = true;
    this.demoAssetService
      .getAssetPopup(data.demo.id)
      .pipe(
        takeUntilDestroyed(),
        map(res => {
          this.loading = false;
          this.demo = res;
          this.industries = res.industries ?? [];
          this.materials = res.materials ?? [];
          this.modules = res.modules ?? [];
          this.lastUpdate = new Date(res.lastUpdate);
        })
      )
      .subscribe();

    this.canAddToCollection = data.canAddToCollection;
    this.startFullScreen = data.startFullScreen;
  }

  ngAfterContentChecked(): void {
    const industriesChipsDiv = this.industriesChips?.nativeElement as HTMLDivElement;
    if (industriesChipsDiv) {
      this.industriesExpandable = industriesChipsDiv.clientHeight < industriesChipsDiv.scrollHeight;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  clickButton(event: Event): void {
    event.stopPropagation();
    this.collectionService.addToCollection(this.data.demo);
    this.dialogRef.close();
  }
}
